module.exports = __webpack_public_path__ + "img/login.b956d349.png";